import { Alert, FormGroup } from "@blueprintjs/core";
import { MDBBtn, MDBCol, MDBRow } from "mdbreact";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import ReactJson from "react-json-view";
import { ILegisWebLucro } from "../../model";
import { LegisWebStore } from "../../stores/admin/LegisWebStore";
import { AppStore } from "../../stores/AppStore";
import { toast } from "react-toastify";
import { Pager } from "../utils/Pager";

const InputMask = require("react-input-mask");

interface LegisWebLucroPageProps {
}

interface LegisWebLucroPageState {
}

@observer
export class LegisWebLucroPage
  extends React.Component<LegisWebLucroPageProps, LegisWebLucroPageState>
{
  obs = observable({
    ncm: "" as string,
    page: 1 as number,
    viewing: {} as ILegisWebLucro,
  })


  constructor(props) {
    super(props);
    this.state = { handlePageChange: props.handlePageChange };
  }

  async componentDidMount() {
    AppStore.setTitle("Legis Web - Lucro Real");
    LegisWebStore.legisWebLucroLoad(1);
  }

  handlePageChange = async (page: number) => {
    LegisWebStore.legisWebLucroLoad(page);
    this.obs.page = page;
  };

  handleBuscaNcm = async () => {
    if (this.obs.ncm != "") {
      await LegisWebStore.buscaNcmLucro(this.obs.ncm);
    } else {
      toast.warning('Digite um NCM.', {});
    }
  };

  render() {
    const handleViewDetalhes = (resp: ILegisWebLucro) => {
      this.obs.viewing = resp;
      LegisWebStore.obs.viewLucroDetalhes = true;
    };

    function buttonFormatterResposta(cell, row) {
      return (
        <>
          <MDBBtn
            color="default"
            rounded
            size="sm"
            onClick={(e) => handleViewDetalhes(row)}
          >
            <img src="/images/view.png" width="18px" />
          </MDBBtn>
        </>
      );
    }

    return (
      <>
        <MDBRow xl="12" lg="12" md="12" sm="12">
          <MDBCol xl="2" lg="2" md="2" sm="2">
            <FormGroup label="NCM">
              <InputMask
                mask="9999.99.99"
                className="form-control"
                onChange={(e) => this.obs.ncm = e.target.value}
              />
            </FormGroup>
          </MDBCol>

          <MDBCol md="2">
            <MDBBtn
              className="btnDefault btnBuscarNfe mt25"
              onClick={this.handleBuscaNcm}
            >
              Buscar
            </MDBBtn>
          </MDBCol>
        </MDBRow>

        <div data-tut="table">
          <BootstrapTable
            className="TableDefault"
            ref="table"
            data={LegisWebStore.obs.legisweb_lucro}
          >
            <TableHeaderColumn dataField="_id" isKey={true} hidden width="1%">
              #
            </TableHeaderColumn>
            <TableHeaderColumn dataField="ncm" dataSort={true} width="10%">
              NCM
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="descricao"
              dataSort={true}
              width="10%"
            >
              Descrição
            </TableHeaderColumn>
            <TableHeaderColumn dataFormat={buttonFormatterResposta} width="15%">
              Detalhes
            </TableHeaderColumn>
          </BootstrapTable>
        </div>

        <Alert
          confirmButtonText="Fechar"
          isOpen={LegisWebStore.obs.viewLucroDetalhes}
          onClose={() => LegisWebStore.obs.viewLucroDetalhes = false}
          canOutsideClickCancel={true}
          className="AlertResposta"
        >
          <h2 className="titleSEFAZ">Detalhes</h2>

          <div className="heightResposta">
            <ReactJson
              collapsed={true}
              displayDataTypes={false}
              src={this.obs.viewing}
            />
          </div>
        </Alert>

        <div style={{ marginTop: 5, float: "right", marginBottom: 120 }}>
          <Pager
            currentPage={this.obs.page}
            totalCount={LegisWebStore.obs.lengthLucroProduto}
            pageSize={15}
            onPageChange={this.handlePageChange}
          />
        </div>
      </>
    );
  }
}
